/*************************************************/
/* COUNTDOWN                                     */
/*************************************************/

export function countdown() {
    const countdownSelector = '.countdown';
    const daysSelector = '.countdown__days > span';
    const hoursSelector = '.countdown__hours > span';
    const minutesSelector = '.countdown__minutes > span';
    const secondsSelector = '.countdown__seconds > span';

    const init = () => {
        
        if (document.querySelector(countdownSelector)) {
            const countdownInterval = setInterval(() => {

                //Get elements
                const daysElement = document.querySelector(daysSelector);
                const hoursElement = document.querySelector(hoursSelector);
                const minutesElement = document.querySelector(minutesSelector);
                const secondsElement = document.querySelector(secondsSelector);

                if (daysElement && hoursElement && minutesElement && secondsElement) {

                    //Get current values
                    const currentSecondsValue = parseInt(secondsElement.innerText);
                    const currentMinutesValue = parseInt(minutesElement.innerText);
                    const currentHoursValue = parseInt(hoursElement.innerText);
                    const currentDaysValue = parseInt(daysElement.innerText);

                    //Figure out if we should even continue counting
                    if (currentSecondsValue === 0 && currentMinutesValue === 0 && currentHoursValue === 0 && currentDaysValue === 0) {
                        clearInterval(countdownInterval);
                        return false;
                    }

                    //Get seconds
                    let newSecondsValue = currentSecondsValue;
                    if (currentSecondsValue === 0) {
                        newSecondsValue = 59;
                    } else {
                        newSecondsValue = newSecondsValue - 1;
                    }

                    //Get minutes
                    let newMinutesValue = currentMinutesValue;
                    if (newSecondsValue === 59) {
                        if (currentMinutesValue === 0) {
                            newMinutesValue = 59;
                        } else {
                            newMinutesValue = newMinutesValue - 1;
                        }
                    }

                    //Get hours
                    let newHoursValue = currentHoursValue;
                    if (newMinutesValue === 59 && newSecondsValue === 59) {
                        if (currentHoursValue === 0) {
                            newHoursValue = 23;
                        } else {
                            newHoursValue = newHoursValue - 1;
                        }
                    }

                    //Get days
                    let newDaysValue = currentDaysValue;
                    if (newHoursValue === 23 && newMinutesValue === 59 && newSecondsValue === 59) {
                        if (currentDaysValue > 0) {
                            newDaysValue = newDaysValue - 1;
                        } else {
                            newDaysValue = 0;
                        }
                    }

                    //Set new values
                    secondsElement.innerText = newSecondsValue;
                    minutesElement.innerText = newMinutesValue;
                    hoursElement.innerText = newHoursValue;
                    daysElement.innerText = newDaysValue;
                } else {
                    clearInterval(countdownInterval);
                    return false;
                }
            }, 1000);
        }
    };

    init();
}

